import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import demo from "../../assets/Home/demo.jpg";
import cogni from "../../assets/Images-new/Raiden ARCVIZ.png";
import simx from "../../assets/Images-new/Raiden_Verse.png";
import arcviz from "../../assets/Poster/RaidenCogni+.png";
import verse from "../../assets/Poster/RaidenSimX.png";
import sim from "../../assets/Poster/Poster1.png";
import arc from '../../assets/Mobile_view/Poster2.png'
import ver from '../../assets/Poster/Poster3.png'
import cog from '../../assets/Mobile_view/Poster4.png'

export default function TestimonialSix() {
  // const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  // const isDesktop = useMediaQuery({ query: "(min-width: 767px)" });
  const settings = {
    dots: true,
    arrow: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: true,
    centerPadding: "5px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const settings2 = {
    dots: true,
    arrow: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: true,
    centerPadding: "5px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const TestimonilContent = [
    { img2: ver },
    { img2: arc },
    { img2: sim },
    { img2: cog },
   
  
  ];
  const TestimonilContent2 = [
   
    { img: verse },
    { img: arcviz },
    { img: simx },
    { img: cogni },
  ];
  return (
    <div >

      <Slider {...settings} className="mobile-img d-none">
        {TestimonilContent.map((val, i) => (
          <div className="item" key={i}>
            <div className="feedback-wrapper pb-4">
            
              <img className="" src={val.img2} alt="mobile" />

            </div>
          </div>
        ))}
      </Slider>
      <Slider {...settings2} className="desktop-img ">
        {TestimonilContent2.map((val, i) => (
          <div className="item" key={i}>
            <div className="feedback-wrapper pb-4">
              {/* Desktop Image */}
              <img
                className="object-fit-cover img-80"
                src={val.img}
                alt="screen"
              />

              {/* Mobile Image */}
              {/* <img className="mobile-img" src={val.img2} alt="mobile" /> */}

            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
